<div class="bar-chart">
  @if (dataset()?.data?.length) {
    <highcharts-chart
      class="highcharts-light"
      [options]="chartOptions()"
    />
  } @else {
    <div class="empty">No data available.</div>
  }
</div>
